/**
 * 浏览行为埋点（仅 localStorage，不发任何请求，不含个人信息）。
 * 记录：看过哪些商品、看了几次、可见停留多久、是否加过购物车。
 * 消费方：assets/hs-reco-engine.js（商详「猜你喜欢」排序）。
 */
(function () {
  'use strict';

  var KEY = 'hs_viewed_products';
  var MAX_ITEMS = 40;
  var MAX_AGE_MS = 60 * 24 * 60 * 60 * 1000; // 60 天
  var DWELL_CAP_MS = 5 * 60 * 1000; // 单次访问最多记 5 分钟，防挂着页面刷分

  function readPayload() {
    var el = document.querySelector('[data-hs-view-track]');
    if (!el) return null;
    try {
      var p = JSON.parse(el.textContent || '');
      return p && p.h ? p : null;
    } catch (e) {
      return null;
    }
  }

  function readStore() {
    var raw = null;
    try {
      raw = JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (e) {
      raw = null;
    }
    if (!raw) return { v: 2, items: [] };
    // v1 是裸数组 [{id, handle, collections, at}]，就地升级，老数据不丢
    if (Array.isArray(raw)) {
      return {
        v: 2,
        items: raw
          .filter(function (x) {
            return x && (x.handle || x.h);
          })
          .map(function (x) {
            return {
              h: x.handle || x.h,
              id: x.id,
              cols: x.collections || [],
              at: x.at || Date.now(),
              n: 1,
              dwell: 0,
            };
          }),
      };
    }
    if (!raw.items || !Array.isArray(raw.items)) return { v: 2, items: [] };
    raw.v = 2;
    return raw;
  }

  function writeStore(store) {
    var cutoff = Date.now() - MAX_AGE_MS;
    store.items = store.items
      .filter(function (x) {
        return x && x.h && x.at > cutoff;
      })
      .sort(function (a, b) {
        return b.at - a.at;
      })
      .slice(0, MAX_ITEMS);
    try {
      localStorage.setItem(KEY, JSON.stringify(store));
    } catch (e) {
      /* 隐私模式 / 配额满：静默放弃，推荐降级为非个性化 */
    }
  }

  var payload = readPayload();
  if (!payload) return;

  var store = readStore();
  var entry = null;
  for (var i = 0; i < store.items.length; i++) {
    if (store.items[i].h === payload.h) {
      entry = store.items[i];
      break;
    }
  }
  if (!entry) {
    entry = { h: payload.h, n: 0, dwell: 0, atc: 0 };
    store.items.push(entry);
  }

  entry.id = payload.id;
  entry.cat = payload.cat;
  entry.fam = payload.fam;
  entry.cols = payload.cols || [];
  entry.price = payload.price;
  entry.scent = payload.scent;
  entry.stars = payload.stars;
  entry.pet = payload.pet;
  entry.at = Date.now();
  entry.n = (entry.n || 0) + 1;
  entry.dwell = entry.dwell || 0;
  entry.atc = entry.atc || 0;
  writeStore(store);

  // ── 可见停留时长：只累计页面真正可见的时间 ──────────────────
  var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
  var pendingMs = 0;

  function accumulate() {
    if (!visibleSince) return;
    pendingMs += Date.now() - visibleSince;
    visibleSince = 0;
  }

  function flush() {
    accumulate();
    if (pendingMs < 1000) return;
    var add = Math.min(pendingMs, DWELL_CAP_MS);
    pendingMs = 0;
    var s = readStore();
    for (var i = 0; i < s.items.length; i++) {
      if (s.items[i].h === payload.h) {
        s.items[i].dwell = (s.items[i].dwell || 0) + Math.round(add / 1000);
        break;
      }
    }
    writeStore(s);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      visibleSince = Date.now();
    } else {
      flush();
    }
  });
  window.addEventListener('pagehide', flush);
  // 长停留也定期落盘，避免用户直接关标签页时丢数据
  setInterval(flush, 30000);

  // ── 加购意图：比浏览强得多的兴趣信号 ─────────────────────────
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var s = readStore();
      for (var i = 0; i < s.items.length; i++) {
        if (s.items[i].h === payload.h) {
          s.items[i].atc = (s.items[i].atc || 0) + 1;
          s.items[i].at = Date.now();
          break;
        }
      }
      writeStore(s);
    },
    true
  );
})();
